/* eslint-disable prettier/prettier */
/* eslint-disable no-empty */
import moment from 'moment';
import Connection from './Connection';
import { customizeTeamNameLogo } from './MatchTitleFormat';
import Constants from '../constants';
const ID_LENGTH = 36;
const START_LETTERS_ASCII = 97; // Use 64 for uppercase
const ALPHABET_LENGTH = 26;
declare const window: any;
export const generateUniqueID = () =>
  [...new Array(ID_LENGTH)]
    .map(() => String.fromCharCode(START_LETTERS_ASCII + Math.random() * ALPHABET_LENGTH))
    .join('');

export const convertToDollars = (number: number) => {
  let USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumSignificantDigits: 3
  });
  let num = isNaN(number) ? 0 : number;
  return USDollar.format(num);
};
export const RoundedOffAmount = (number: number) => {
  if (isNaN(number)) return 0;
  return parseFloat(parseInt(String(number)).toFixed(2));
};

export const RoundedOffNumber = (number: any) => {
  if (isNaN(number)) return 0;
  return parseFloat(number).toFixed(2);
};

export const calculateMatchDeadline = (matchStartDate: any) => {
  return moment(matchStartDate).valueOf() - moment(new Date()).valueOf();
};

export const getPlayerName = (playerName = '') => {
  try {
    // if (playerName.length <= 14) return playerName
    let playerNameList = playerName.split(' ');
    switch (playerNameList.length) {
      case 1:
        return playerNameList[0];
      case 2:
        return playerNameList[0][0]?.toUpperCase() + ' ' + playerNameList[1];
      case 3:
        return (
          playerNameList[0][0]?.toUpperCase() +
          playerNameList[1][0]?.toUpperCase() +
          ' ' +
          playerNameList[1]
        );
    }
    return playerName;
  } catch (error) {
    return playerName;
  }
};

export const getNoPlayingCount = (allPlayerList = [], myTeamPlayerList = []) => {
  let count = 0;
  myTeamPlayerList.forEach((itemA: { playerId: string; id: string }) => {
    const playerObj = allPlayerList.find(
      (o: { id: string }) => o.id === itemA.playerId || o.id === itemA.id
    );
    if (playerObj) {
      const { playingEleven = false } = playerObj;
      if (!playingEleven) count++;
    }
  });
  return count;
};

export const maskUserName = (firstName = '', lastName = '', userName = '') => {
  let newUserName = '';
  if (userName.match(/^[0-9a-fA-F]{24}$/)) {
    // is this userId
    if (firstName != '') newUserName = `${firstName} ${lastName}`;
    else newUserName = userName?.substr(0, 8).concat('xxxx');
  } else if (userName.match(/^[0-9]{8,14}$/)) {
    // if not userId, but is this phone number
    newUserName = userName?.substr(0, 4).concat('xxxx') + userName?.substr(userName.length - 2);
  } else {
    //if neither userId nor phone number
    newUserName = userName;
  }
  return newUserName;
};

//this method is used to detect web running in web browser or mobile
export const isMobileBrowser_ = () => {
  // if we want a more complete list use this: http://detectmobilebrowsers.com/
  // str.test() is more efficent than str.match()
  // remember str.test is case sensitive

  return /iphone|ipod|android|ie|blackberry|fennec/.test(navigator.userAgent.toLowerCase());
};

export const isDesktopBrowser = !isMobileBrowser_();

export const isMobileBrowser = isMobileBrowser_();

export const isFireboxBrowser = () => {
  return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
};

export const isClientApp = () => {
  return process.env.REACT_APP_THEME === 'iGamio' ? false : true;
};

export const getLowestWinningsRank = (winningsPerPosition: any) => {
  let rank = 0;
  if (winningsPerPosition) {
    Object.keys(winningsPerPosition).forEach(function (key: any) {
      rank += parseInt(winningsPerPosition[key]);
    });
  }
  return rank;
};

export const formattedWinningsPerPosition = (winningsPerPosition: any) => {
  if (winningsPerPosition) {
    let lastPosition = 0;
    let formattedWinningsPerPos = Object.keys(winningsPerPosition)
      .sort((a: any, b: any) => b - a)
      .reduce((prev: any, cur) => {
        let nextKey: any;
        const start = lastPosition;
        const end = lastPosition + winningsPerPosition[cur];

        if (end - start <= 1) {
          nextKey = lastPosition + 1;
        } else {
          nextKey = `${lastPosition + 1} - ${end}`;
        }

        lastPosition = end;
        prev[nextKey] = Number(cur);

        return prev;
      }, {});
    formattedWinningsPerPos = Object.fromEntries(
      Object.entries(formattedWinningsPerPos).sort() || []
    );
    return formattedWinningsPerPos;
  } else {
    return {};
  }
};

export const formatContestLeaderBoard = ({
  myLeaderboard = false,
  userId = '',
  leaderBoardList = [],
  winningsPerPosition = {}
}) => {
  let lowestWinningsRank = getLowestWinningsRank(winningsPerPosition);
  let newList: any = [];
  leaderBoardList.forEach((item: { userId: string; rank: number }) => {
    const isShow = myLeaderboard ? true : userId == item.userId ? false : true;
    if (item.rank <= lowestWinningsRank) {
      newList.push({
        ...item,
        isShow,
        winningZone: true
      });
    } else {
      newList.push({
        ...item,
        isShow,
        winningZone: false
      });
    }
  });
  return newList;
};

export const formatPlayerPointInfo = (pointsList: any = []) => {
  let playerPointObj = {
    Announced: {
      points: 0
    },
    Runs: {
      points: 0
    },
    '4s': {
      points: 0
    },
    '6s': {
      points: 0
    },
    'E/R': {
      points: 0
    },
    'S/R': {
      points: 0
    },
    '30/50/100': {
      points: 0
    },
    Duck: {
      points: 0
    },
    Wickets: {
      points: 0
    },
    'Maiden Over': {
      points: 0
    },
    Catch: {
      points: 0
    },
    'Run Out/Stumping': {
      points: 0
    }
  };
  for (var key in pointsList) {
    if (key === 'startingEleven') {
      playerPointObj['Announced'].points = pointsList['startingEleven'];
    } else if (key === 'run') {
      playerPointObj['Runs'].points = pointsList['run'];
    } else if (key === 'fours') {
      playerPointObj['4s'].points = pointsList['boundary'];
    } else if (key === 'six') {
      playerPointObj['6s'].points = pointsList['six'];
    } else if (key === 'strikeRate') {
      playerPointObj['S/R'].points = pointsList['strikeRate'];
    } else if (key === 'thirtyRuns') {
      playerPointObj['30/50/100'].points =
        pointsList['thirtyRuns'] +
        pointsList['fiftyRuns'] +
        pointsList['halfCentury'] +
        pointsList['century'];
    } else if (key === 'dismissal') {
      playerPointObj['Duck'].points = pointsList['dismissal'];
    } else if (key === 'wicket') {
      playerPointObj['Wickets'].points =
        pointsList['wicket'] +
        pointsList['threeWicketHaul'] +
        pointsList['twoWicketHaul'] +
        pointsList['fourWicketHaul'] +
        pointsList['fiveWicketHaul'];
    } else if (key === 'maidenOver') {
      // Maiden Over
      playerPointObj['Maiden Over'].points = pointsList['maidenOver'];
    } else if (key === 'economyRate') {
      // Maiden Over
      playerPointObj['E/R'].points = pointsList['economyRate'];
    } else if (key === 'catch') {
      playerPointObj['Catch'].points = pointsList['catch'];
    } else if (key === 'runOut') {
      playerPointObj['Run Out/Stumping'].points =
        pointsList['runOut'] +
        pointsList['runOutCatch'] +
        pointsList['runOutThrow'] +
        pointsList['stump'];
    }
  }
  return playerPointObj;
};

export const getContestFilteredList = (
  contestList: any,
  contestFilterList: any,
  contestTypeObjList: any
) => {
  let updateList = [];
  const newContestList = [...contestList];
  //for entry fees
  const entryList = contestFilterList[0].list;
  let isAppliedFilter = entryList.findIndex((itm: { isSelected: any }) => itm.isSelected);
  if (isAppliedFilter !== -1) {
    updateList = newContestList.filter(function (item) {
      const { entryFee } = item;
      let index = entryList.findIndex(
        (itm: { min: number; max: number; isSelected: any }) =>
          itm.min <= entryFee && itm.max >= entryFee && itm.isSelected
      );
      return index !== -1 ? true : false;
    });
  } else {
    updateList = newContestList;
  }

  // for no of teams
  const noOfTeamList = contestFilterList[1].list;
  isAppliedFilter = noOfTeamList.findIndex((itm: { isSelected: any }) => itm.isSelected);
  if (isAppliedFilter !== -1) {
    updateList = updateList.filter(function (item) {
      const { maximumPlayers: maxPlayer = 0 } = item;
      let index = noOfTeamList.findIndex(
        (itm: { min: number; max: number; isSelected: any }) =>
          itm.min <= maxPlayer && itm.max >= maxPlayer && itm.isSelected
      );
      return index !== -1 ? true : false;
    });
  }

  //for prize pool
  const prizePoolList = contestFilterList[2].list;
  isAppliedFilter = prizePoolList.findIndex((itm: { isSelected: any }) => itm.isSelected);
  if (isAppliedFilter !== -1) {
    updateList = updateList.filter(function (item) {
      const { winningsAmount: winAmt = 0 } = item;
      let index = prizePoolList.findIndex(
        (itm: { min: number; max: number; isSelected: any }) =>
          itm.min <= winAmt && itm.max >= winAmt && itm.isSelected
      );
      return index !== -1 ? true : false;
    });
  }

  //for contest single entry
  const contestTypes = contestFilterList[3].list;
  isAppliedFilter = contestTypes.findIndex((itm: { isSelected: any }) => itm.isSelected);
  if (isAppliedFilter !== -1) {
    updateList = updateList.filter(function (item) {
      const { isConfirmed = false, contestTypeId } = item;
      const contestType = contestTypeObjList[contestTypeId];
      const { acceptsMultipleEntry = false } = contestType;

      const singleEntryIndex = contestTypes.findIndex(
        (itm: { title: string; isSelected: any }) => itm.title === 'Single Entry' && itm.isSelected
      );

      const multipleEntryIndex = contestTypes.findIndex(
        (itm: { title: string; isSelected: any }) => itm.title === 'Multi Entry' && itm.isSelected
      );

      const isConfirmedIndex = contestTypes.findIndex(
        (itm: { title: string; isSelected: any }) => itm.title === 'Confirmed' && itm.isSelected
      );

      return (singleEntryIndex !== -1 && !acceptsMultipleEntry) ||
        (multipleEntryIndex !== -1 && acceptsMultipleEntry) ||
        (isConfirmedIndex !== -1 && isConfirmed)
        ? true
        : false;
    });
  }
  return updateList;
};

export const getPokerWebEnableStatus = () => {
  const { REACT_APP_ENABLE_POKER_WEB = '' } = process.env;
  return REACT_APP_ENABLE_POKER_WEB === 'true';
};

export const isPokerEnabled = getPokerWebEnableStatus();

export const getTrumpCardEnableStatus = () => {
  const { REACT_APP_ENABLE_TRUMP_CARD = '' } = process.env;
  return REACT_APP_ENABLE_TRUMP_CARD === 'true';
};

export const isTrumpCardEnabled = getTrumpCardEnableStatus();

export const getMiniGamesEnableStatus = () => {
  const { REACT_APP_ENABLE_MINI_GAMES = '' } = process.env;
  return REACT_APP_ENABLE_MINI_GAMES === 'true';
};

export const isMiniGamesEnabled = getMiniGamesEnableStatus();

export const getFantasySubstituteEnableStatus = () => {
  const { REACT_APP_ENABLE_FANTASY_SUBSTITUTE = '' } = process.env;
  return REACT_APP_ENABLE_FANTASY_SUBSTITUTE === 'true';
};

export const isFantasySubstituteEnabled = getFantasySubstituteEnableStatus();

export const isMatchInScheduled = ({
  matchStatus = 1,
  gameState = 0,
  matchDelayed = false,
  gameType = ''
}) => {
  if (gameType === Constants.GameType.FANTASY_FOOTBALL)
    return matchStatus === 1 || matchDelayed || (matchStatus === 3 && gameState === 1);
  // for cricket Match status code 3 = live, 2 = result, 1 = upcoming, 4 = canceled
  else
    return (
      matchStatus === 1 ||
      matchDelayed ||
      gameState === 4 ||
      (matchStatus === 3 && (gameState === 0 || gameState === 1))
    );
};

export const isMatchInDelay = ({
  gameType = '',
  matchStatus = 1,
  gameState = 0,
  matchDelayed = false
}) => {
  if (gameType === Constants.GameType.FANTASY_FOOTBALL) return matchDelayed;
  else
    return (
      matchDelayed || gameState === 4 || (matchStatus === 3 && (gameState === 0 || gameState === 1))
    );
};

export const hideTabBarForFantasy = (routeName: string) => {
  return [
    'SubstituteTeamPlayer',
    'ContestDetails',
    'TeamPreview',
    'CreateTeam',
    'AllContest',
    'ChooseCaptain',
    'SubstituteTeam',
    'ContestShareLanding'
  ].includes(routeName);
};

export const isBannedStateForFantasySports = (stateName: string) => {
  return ['Andhra Pradesh', 'Assam', 'Odisha', 'Telangana', 'Nagaland', 'Sikkim'].includes(
    stateName
  );
};

export const isBannedStateForPoker = (stateName: string) => {
  return ['Tamil Nadu'].includes(stateName);
};

export const getMatchDelayTime = (matchTime: string | number | Date) => {
  const delayTimer = 3 * 60 * 1000;
  let timestampDifference = new Date().getTime() - new Date(matchTime).getTime();
  timestampDifference = timestampDifference % delayTimer;
  timestampDifference = delayTimer - timestampDifference;
  return timestampDifference;
};

export const shiftFixtureMatch = (list = []) => {
  const priorityMatchList: any[] = [];
  const unPriorityMatchList: any[] = [];
  list.forEach((item: any) => {
    if (item.priority) {
      priorityMatchList.push(item);
    } else {
      unPriorityMatchList.push(item);
    }
  });
  priorityMatchList.sort((aMatchItem, bMatchItem) => {
    const { priority: aMatchPriority = 0 } = aMatchItem;
    const { priority: bMatchPriority = 0 } = bMatchItem;
    return aMatchPriority - bMatchPriority;
  });
  return [...priorityMatchList, ...unPriorityMatchList];
};
export const formatNumber = (value: number) => {
  var val: any = Math.abs(value);
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(1) + ' Cr';
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(1) + ' Lac';
  }
  return val;
};

export const formatPrizeNumber = (value: number) => {
  var val: any = Math.abs(value);
  if (val >= 10000000) {
    return (val / 10000000).toFixed(1) + ' Cr';
  } else if (val >= 100000) {
    return (val / 100000).toFixed(1) + ' Lac';
  }
  return val;
};

export const formatTeamSpots = (value: number) => {
  var val: any = Math.abs(value);
  if (val >= 10000000) {
    return (val / 10000000).toFixed(1) + ' Cr teams';
  } else if (val >= 100000) {
    return (val / 100000).toFixed(1) + ' Lac teams';
  }
  return val + ' teams';
};

export const getRealBalanceObj = (balanceInfo: any) => {
  const {
    bonusWallet = 0,
    gameWallet = 0,
    primaryWallet = 0,
    pokerWallet = 0,
    cashbackWallet = 0
  } = balanceInfo;
  return {
    bonusBalance: RoundedOffAmount(bonusWallet),
    gameBalance: RoundedOffAmount(gameWallet),
    primaryBalance: RoundedOffAmount(primaryWallet),
    pokerBalance: RoundedOffAmount(pokerWallet),
    cashbackBalance: RoundedOffAmount(cashbackWallet),
    totalBalance: RoundedOffAmount(
      bonusWallet + gameWallet + primaryWallet + pokerWallet + cashbackWallet
    )
  };
};

export const calculateUsableBonus = (entryFee = 0, bonusPercentage = 0, bonusBalance = 0) => {
  const usableEntryFeeBonusAmount = entryFee * (bonusPercentage / 100);
  const usableBonus: any =
    bonusBalance > usableEntryFeeBonusAmount ? usableEntryFeeBonusAmount : bonusBalance;
  if (isNaN(usableBonus)) return 0;
  return parseFloat(usableBonus).toFixed(2);
};

export const getDefaultPhoneData = (phones: any) => {
  const [phone] = phones;
  return {
    phoneId: phone ? phone.id : '',
    defaultPhone: phone ? phone.phone : ''
  };
};

export const getDefaultEmailData = (emails: any) => {
  const [email] = emails;
  return {
    emailId: email ? email.id : '',
    defaultEmail: email ? email.email : ''
  };
};

export const getBankAccountData = (bankAccounts: any) => {
  let bankAccountId = '';
  let bankAccountsObj = bankAccounts.find(
    (item: any) =>
      (item.status === 'verified' && item.default === true) || item.status === 'verified'
  );
  if (bankAccountsObj) {
    const { _id = '' } = bankAccountsObj;
    bankAccountId = _id;
  }
  return {
    bankAccountId,
    ...bankAccountsObj
  };
};

export const isAccountVerified = (statuses: any) => {
  const {
    bankAccounts: bankAccountStatus = 'not_set',
    pan: panStatus = 'not_set',
    emails: emailsStatus = 'not_set',
    phones: phonesStatus = 'not_set',
    addresses: addressesStatus = 'not_set'
  } = statuses;
  return (
    bankAccountStatus === 'verified' &&
    panStatus === 'verified' &&
    emailsStatus === 'verified' &&
    phonesStatus === 'verified' &&
    addressesStatus === 'verified'
  );
};

const formatCricketTeam = (team: any, title: any) => {
  const customizeTeam = customizeTeamNameLogo(title, team?.short_name);
  return {
    teamId: team?.team_id,
    logoURL: team?.logo_url,
    fallbackURL: team?.logo_url,
    shortName: customizeTeam?.shortName,
    name: team.name
  };
};

const formatKabaddiTeam = (team: any, title: any, gameType: any) => {
  const customizeTeam = customizeTeamNameLogo(title, team.shortname);
  return {
    teamId: team?.tid,
    logoURL: `${Connection.getMatchTeamURL(team.tid, gameType)}`,
    fallbackURL: team?.logo,
    shortName: customizeTeam?.shortName?.substring(0, 3).toUpperCase(),
    name: team?.tname
  };
};

const formatFootballTeam = (team: any, title: any) => {
  const customizeTeam = customizeTeamNameLogo(title, team.abbr);
  return {
    teamId: team?.tid,
    logoURL: team?.logo,
    fallbackURL: team?.logo,
    shortName: customizeTeam?.shortName?.substring(0, 3).toUpperCase(),
    name: team?.tname
  };
};

export const getTeamA = (matchItem: any, gameType: any) => {
  const { teamA = {}, homeTeam = {}, competition = {} } = matchItem || {};
  const { title = '', cname = '' } = competition;
  return gameType === Constants.GameType.FANTASY_KABADDI
    ? formatKabaddiTeam(homeTeam, cname, gameType)
    : gameType === Constants.GameType.FANTASY_FOOTBALL
    ? formatFootballTeam(homeTeam, cname)
    : formatCricketTeam(teamA, title);
};

export const getTeamB = (matchItem: any, gameType: any) => {
  const { teamB = {}, awayTeam = {}, competition = {} } = matchItem || {};
  const { title = '', cname = '' } = competition;
  return gameType === Constants.GameType.FANTASY_KABADDI
    ? formatKabaddiTeam(awayTeam, cname, gameType)
    : gameType === Constants.GameType.FANTASY_FOOTBALL
    ? formatFootballTeam(awayTeam, cname)
    : formatCricketTeam(teamB, title);
};

export const getIstWinner = (formatWinning: { [x: string]: number }) => {
  if (formatWinning) {
    const istWinner: any = `${formatWinning[Object.keys(formatWinning)[0]] / 100}`;
    return isNaN(istWinner) ? 0 : istWinner;
  } else return 0;
};

export const getTeamPlayerCount = (players: any[]) => {
  let wkCount = 0;
  let batsmanCount = 0;
  let allRounderCount = 0;
  let bowlerCount = 0;
  let raiderCount = 0;
  let defenderCount = 0;
  let substituteCount = 0;
  let gkCount = 0;
  let forwardCount = 0;
  let midfielderCount = 0;
  const substitutePlayerObj: any = {};
  players.forEach((item) => {
    if (item?.substitutePlayerId) {
      substitutePlayerObj[item.substitutePlayerId] = item?.substitutePlayerId;
      substituteCount++;
    }
  });

  players.forEach((item: { role: any; playerId: any }) => {
    if (substitutePlayerObj[item.playerId]) return null;
    switch (item.role) {
      case 'wk':
        wkCount++;
        break;
      case 'bat':
        batsmanCount++;
        break;
      case 'all':
        allRounderCount++;
        break;
      case 'allrounder':
        allRounderCount++;
        break;
      case 'bowl':
        bowlerCount++;
        break;
      case 'raider':
        raiderCount++;
        break;
      case 'defender':
        defenderCount++;
        break;
      case 'Defender':
        defenderCount++;
        break;
      case 'Midfielder':
        midfielderCount++;
        break;
      case 'Forward':
        forwardCount++;
        break;
      case 'Goalkeeper':
        gkCount++;
        break;
    }
  });

  return {
    wkCount,
    batsmanCount,
    allRounderCount,
    bowlerCount,
    raiderCount,
    defenderCount,
    substituteCount,
    gkCount,
    midfielderCount,
    forwardCount
  };
};

export const getTeamPreviewPlayer = ({
  players = [],
  matchAllPlayersList = [],
  teamA = {} as any,
  teamB = {} as any,
  captainId = '',
  viceCaptainId = '',
  // eslint-disable-next-line no-unused-vars
  gameType = ''
}) => {
  let userTeamScore = 0 as number;
  let playerList = [];
  let wkKeepersList: any[] = [];
  let batsmanList: any[] = [];
  let allRoundersList: any[] = [];
  let bowlersList: any[] = [];
  let raiderList: any[] = [];
  let defenderList: any[] = [];
  let gkKeepersList: any[] = [];
  let forwardList: any[] = [];
  let midfielderList: any[] = [];
  let sectionPlayerList = [];

  const getPoint = ({ userTeamScore = 0, itemA = {} as any, points = 0 }) => {
    return (
      userTeamScore +
      (captainId === itemA?.id || captainId === itemA?.playerId
        ? points * 2
        : viceCaptainId === itemA?.id || viceCaptainId === itemA?.playerId
        ? points * 1.5
        : points)
    );
  };

  players.forEach((itemA: any) => {
    const playerObj: any = matchAllPlayersList.find(
      (o: any) => o?.id === itemA?.playerId || o?.id === itemA?.id
    );
    let teamName = itemA?.teamId === teamA?.teamId ? teamA?.shortName : teamB?.shortName;
    const points = playerObj?.points || 0;
    const totalPoints = playerObj?.totalPoints || 0;
    const isNeedToUsedTotalPoint =
      gameType === Constants.GameType.FANTASY_KABADDI ||
      gameType === Constants.GameType.FANTASY_FOOTBALL;
    if (isNeedToUsedTotalPoint) {
      userTeamScore = getPoint({ userTeamScore, itemA, points: totalPoints });
    } else {
      userTeamScore = getPoint({ userTeamScore, itemA, points });
    }

    let playerItem = {
      ...itemA,
      ...playerObj,
      teamName,
      isCaptain: captainId === itemA?.id || captainId === itemA?.playerId ? true : false,
      isViceCaptain: viceCaptainId === itemA?.id || viceCaptainId === itemA?.playerId ? true : false
    };

    playerList.push(playerItem);
    switch (itemA?.role) {
      case 'wk':
        wkKeepersList.push(playerItem);
        break;
      case 'wkbat':
        wkKeepersList.push(playerItem);
        break;
      case 'bat':
        batsmanList.push(playerItem);
        break;
      case 'all':
        allRoundersList.push(playerItem);
        break;
      case 'bowl':
        bowlersList.push(playerItem);
        break;
      case 'allrounder':
        allRoundersList.push(playerItem);
        break;
      case 'raider':
        raiderList.push(playerItem);
        break;
      case 'defender':
        defenderList.push(playerItem);
        break;
      case 'Defender':
        defenderList.push(playerItem);
        break;
      case 'Goalkeeper':
        gkKeepersList.push(playerItem);
        break;
      case 'Forward':
        forwardList.push(playerItem);
        break;
      case 'Midfielder':
        midfielderList.push(playerItem);
        break;
    }
  });

  // for football
  if (gkKeepersList.length > 0)
    sectionPlayerList.push({
      title: 'Goal Keeper',
      data: gkKeepersList
    });

  if (defenderList.length > 0)
    sectionPlayerList.push({
      title: 'Defenders',
      data: defenderList
    });

  if (midfielderList.length > 0)
    sectionPlayerList.push({
      title: 'Midfielder',
      data: midfielderList
    });

  if (forwardList.length > 0)
    sectionPlayerList.push({
      title: 'Forward',
      data: forwardList
    });

  // for cricket
  if (wkKeepersList.length > 0)
    sectionPlayerList.push({
      title: 'Wicket Keepers',
      data: wkKeepersList
    });
  if (batsmanList.length > 0)
    sectionPlayerList.push({
      title: 'Batters',
      data: batsmanList
    });
  if (allRoundersList.length > 0)
    sectionPlayerList.push({
      title: 'All Rounders',
      data: allRoundersList
    });
  if (bowlersList.length > 0)
    sectionPlayerList.push({
      title: 'Bowlers',
      data: bowlersList
    });

  if (raiderList.length > 0)
    sectionPlayerList.push({
      title: 'Raiders',
      data: raiderList
    });

  return {
    sectionPlayerList,
    userTeamScore
  };
};

export const formatDepositTransactions = (data: any) => {
  let transactionList = [] as any;
  data.forEach((transactionItem: any) => {
    const {
      userBonuses = {},
      userDeposits = [],
      userCashbacks = [],
      status = 'expired',
      comment: tComment = ''
    } = transactionItem;
    if (userBonuses.length > 0) {
      userBonuses.forEach((userBonusItem: any) => {
        transactionList.push({
          ...transactionItem,
          ...userBonusItem,
          isBonus: true
        });
      });
    }
    if (userCashbacks.length > 0) {
      userCashbacks.forEach((userCashbackItem: any) => {
        transactionList.push({
          ...transactionItem,
          ...userCashbackItem,
          isCashback: true,
          isCashBackExpired: status === 'expired'
        });
      });
    }

    if (userDeposits.length > 0) {
      userDeposits.forEach((userDepositItem: any) => {
        transactionList.push({
          ...transactionItem,
          ...userDepositItem,
          tComment
        });
      });
    }
    if (status === 'pending') {
      transactionList.push(transactionItem);
    }
  });
  transactionList.sort(function (
    a: { createdOn: moment.MomentInput },
    b: { createdOn: moment.MomentInput }
  ) {
    return (
      moment(b.createdOn, 'YYYY-MM-DD HH:mm:ss').valueOf() -
      moment(a.createdOn, 'YYYY-MM-DD HH:mm:ss').valueOf()
    );
  });
  return transactionList;
};

export const formatGamingTransactions = (data = []) => {
  let sectionList = [] as any;
  data.forEach((item) => {
    let transactionList = [];
    let isPoker = false;
    let entryCount = 0;
    let {
      primaryWalletPayment = [],
      bonusWalletPayment = [],
      gameWalletPayment = [],
      pokerWalletPayment = [],
      cashbackWalletPayment = [],
      game = '',
      entryFee = 0,
      gameId = '',
      matchTitle = null
    } = item;

    let primaryWalletRefund = 0;
    let primaryWalletEntryFee = 0;
    let bonusWalletRefund = 0;
    let bonusWalletEntryFee = 0;
    let gameWalletRefund = 0;
    let gameWalletEntryFee = 0;
    let pokerWalletRefund = 0;
    let pokerWalletEntryFee = 0;
    let cashbackWalletRefund = 0;
    let cashbackWalletEntryFee = 0;
    let totalWinnings = 0;
    let totalTax = 0;

    primaryWalletPayment.forEach((item: any) => {
      if (item.amount == 0) {
        entryCount++;
      }
      if (item.transactionType === 'credit' && item.refund) {
        primaryWalletRefund += item.amount;
      } else if (item.transactionType === 'debit') {
        primaryWalletEntryFee += item.amount;
      }
    });
    bonusWalletPayment.forEach((item: any) => {
      if (item.transactionType === 'credit' && item.refund) {
        bonusWalletRefund += item.amount;
      } else if (item.transactionType === 'debit') {
        bonusWalletEntryFee += item.amount;
      }
    });
    gameWalletPayment.forEach((item: any) => {
      if (item.transactionType === 'credit' && item.refund) {
        gameWalletRefund += item.amount;
      } else if (item.transactionType === 'credit') {
        totalTax += item.tax;
        totalWinnings += item.amount;
      } else if (item.transactionType === 'debit') {
        gameWalletEntryFee += item.amount;
      }
    });
    pokerWalletPayment.forEach((item: any) => {
      isPoker = true;
      if (item.transactionType === 'credit' && item.refund) {
        pokerWalletRefund += item.amount;
      } else if (item.transactionType === 'credit') {
        totalWinnings += item.amount;
      } else if (item.transactionType === 'debit') {
        pokerWalletEntryFee += item.amount;
      }
    });
    cashbackWalletPayment.forEach((item: any) => {
      if (item.transactionType === 'credit' && item.refund) {
        cashbackWalletRefund += item.amount;
      } else if (item.transactionType === 'debit') {
        cashbackWalletEntryFee += item.amount;
      }
    });
    const totalRefund =
      primaryWalletRefund +
      gameWalletRefund +
      bonusWalletRefund +
      pokerWalletRefund +
      cashbackWalletRefund;
    const totalEntryFees =
      primaryWalletEntryFee +
      bonusWalletEntryFee +
      gameWalletEntryFee +
      pokerWalletEntryFee +
      cashbackWalletEntryFee;
    transactionList.push({
      transactionType: 'debit',
      refund: false,
      isPoker,
      amount: totalEntryFees,
      walletBreakup: {
        primaryWalletEntryFee,
        bonusWalletEntryFee,
        gameWalletEntryFee,
        pokerWalletEntryFee,
        cashbackWalletEntryFee
      }
    });

    if (totalRefund > 0) {
      transactionList.push({
        transactionType: 'credit',
        refund: true,
        isPoker,
        amount: totalRefund,
        walletBreakup: {
          primaryWalletRefund,
          bonusWalletRefund,
          pokerWalletRefund,
          gameWalletRefund,
          cashbackWalletRefund
        }
      });
    }

    if (totalWinnings > 0) {
      transactionList.push({
        transactionType: 'credit',
        refund: false,
        isPoker,
        totalTax,
        amount: totalWinnings,
        walletBreakup: {
          totalWinnings
        }
      });
    }
    const totalEntryCount = entryFee > 0 ? totalEntryFees / entryFee : entryCount;
    sectionList.push({
      header: {
        game,
        entryFee,
        gameId,
        matchTitle,
        isPoker,
        totalEntryCount
      },
      data: transactionList
    });
  });
  return sectionList;
};

export const getDistanceFromLatLonInKm = (lat1 = 0.0, lon1 = 0.0, lat2 = 0.0, lon2 = 0.0) => {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
};

const deg2rad = (deg: number) => {
  return deg * (Math.PI / 180);
};

export const getRouteObjByGame = (gameType = '') => {
  let routeObj = {
    my_contests: '/my_contests',
    my_teams: '/my_teams',
    create_team: '/create_team',
    choose_captain: '/choose_captain',
    team_preview: '/team_preview',
    home_tab: '/cricket',
    all_contest: '/all_contest',
    contest_details: '/contest_details'
  };
  switch (gameType) {
    case Constants.GameType.FANTASY_SUBSTITUTION:
      return {
        ...routeObj,
        home_tab: '/substitute',
        create_team: '/create_team_substitute',
        choose_captain: '/choose_captain_substitute',
        team_preview: '/substitute_team',
        substitute_team_player: '/substitute_team_player',
        my_teams: '/my_teams_substitute'
      };
    case Constants.GameType.FANTASY_KABADDI:
      return {
        ...routeObj,
        home_tab: '/kabaddi',
        create_team: '/create_team_kabaddi',
        choose_captain: '/choose_captain_kabaddi',
        team_preview: '/team_preview',
        my_teams: '/my_teams'
      };
    case Constants.GameType.FANTASY_YES_NO:
      return {
        ...routeObj,
        home_tab: '/yes_no',
        all_contest: '/yn_all_contest',
        contest_details: '/yn_contest_details',
        my_contests: '/yn_my_contests',
        team_preview: 'yn_preview_answer'
      };
    case Constants.GameType.FANTASY_FOOTBALL:
      return {
        ...routeObj,
        home_tab: '/football',
        create_team: '/create_team_football'
      };
    case 'STANDARD':
      return routeObj;
    default:
      return routeObj;
  }
};

export const getIdFromLink = (link = '') => {
  const lastIndex = link.lastIndexOf('/');
  return link.substring(lastIndex + 1);
};

export const isOverEighteen = (birthday: any) => {
  let ageDifMs = Date.now() - new Date(birthday).getTime();
  let ageDate = new Date(ageDifMs);
  let age = Math.abs(ageDate.getUTCFullYear() - 1970);
  if (age > 17) {
    return true;
  } else {
    return false;
  }
};

export const bytesToMegaBytes = (bytes: any) => {
  return bytes / (1024 * 1024);
};

export const getPlatformOS = async () => {
  return window?.OS ? window.OS : 'Desktop';
};

export const isWebview = Boolean(window.ReactNativeWebView);

export const profilerCallback = (
  id: any,
  phase: any,
  actualTime: any,
  baseTime: any,
  startTime: any,
  commitTime: any
): any => {
  console.log('profiler', id, phase, actualTime, baseTime, startTime, commitTime);
};

export const removePrefixOfName = (nameWithPrefix = '') => {
  const regex = /(Mr|MR|Ms|MS|Miss|MISS|Mrs|MRS|Dr|DR|Sir|SIR)(\.?)\s/;
  const match = regex.exec(nameWithPrefix);
  const name = match !== null ? nameWithPrefix.replace(match[0], '') : nameWithPrefix;
  return name;
};

export const documentMatchName = (name1 = '', name2 = '') => {
  name1 = removePrefixOfName(name1.toUpperCase());
  name2 = removePrefixOfName(name2.toUpperCase());
  if (!name1 || !name2) return false;
  return (
    name1.replace(/ /g, '').toUpperCase().substring(0, 3) !=
    name2.replace(/ /g, '').toUpperCase().substring(0, 3)
  );
};

export const isGadgetLeague = (title = '') => {
  return title?.trim() === 'gadget_league' ? true : false;
};

export const getLeaderBoardTypeData = (
  contestCategoryId = '',
  matchTitle = '',
  entryAmount = 0,
  startDate = '',
  gameType = Constants.GameType.FANTASY_CRICKET
) => {
  const data = {
    isSL: false,
    isGL: false,
    isWeeklyGL: false,
    isShowLeaderboard: false
  };
  if (gameType != Constants.GameType.FANTASY_CRICKET) return data;
  const GLCategoryIdList = [
    '6182d2fcb276f100214b184d',
    '618708a6d2cef8001e66898f',
    '6241e8d3eea82e00210cec6a'
  ];
  const GLCategoryIdListDev = ['618284340d1e16001ef3297e', '61817f8fb2569b001f9ddedd'];
  const giveAwayCategoryIdList = ['6182d001c31444001c11ed0d'];
  const type = [...GLCategoryIdList, ...GLCategoryIdListDev].includes(contestCategoryId)
    ? 'GL'
    : giveAwayCategoryIdList.includes(contestCategoryId)
    ? ''
    : 'SL';
  if (entryAmount >= 10000 && isInLeaderBoardDateRange(startDate)) {
    data.isShowLeaderboard = true;
    data.isWeeklyGL = type === 'SL';
  }
  if (matchTitle === 'Indian T-20 League (T20)') {
    data.isShowLeaderboard = true;
    data.isGL = type === 'GL';
    data.isSL = type === 'SL';
  }
  return data;
};

export const isInLeaderBoardDateRange = (date: moment.MomentInput) => {
  const lStart = moment('2022-08-27').format('YYYY-MM-DD');
  const lEnd = moment('2022-09-27').format('YYYY-MM-DD');
  const matchStart = moment(date).format('YYYY-MM-DD');
  if (matchStart >= lStart && matchStart <= lEnd) return true;
  return false;
};

// weekend leaderboard will show only weekend days
export const isWeekendLeaderboard = (matchItem = {}) => {
  try {
    const { startDate = '' } = matchItem as any;
    const day = moment(startDate).day();
    return [0, 6].includes(day);
  } catch (error) {
    return false;
  }
};

const url = Connection.getBannerUrl();
export const staticPagesLink = `${url}/static/`;
export const assetsLink = `${url}/assets/`;
export const cloudFrontUrl = `${url}/`;

export const getDeviceDimension = () => {
  return {
    width: innerWidth,
    height: innerHeight
  };
};

export const staticGadgetBaseLink = `${url}/gadget-league/`;

export const getGadgetLeagueInfo = (data = '') => {
  let title = '',
    prizeURL = '';
  try {
    const desc = data.split(',');
    prizeURL =
      desc[0] === 'gadget_league' ? Constants.Images.IPhone : `${staticGadgetBaseLink}${desc[0]}`;
    title = desc[1] || 'iPhone 13';
  } catch (error) {}
  return { title, prizeURL };
};

export const isTester = (phone = 0) => {
  try {
    return ['8250277504', '7906568920', '8630563737', '9509371638'].includes(phone + '');
  } catch (error) {
    return false;
  }
};

export const createDeepObject = (data: any) => {
  return JSON.parse(JSON.stringify(data));
};

export const getPropertyValueInPixels = (element: HTMLElement, propertyName: string) => {
  const valueString = window.getComputedStyle(element, null).getPropertyValue(propertyName);
  return parseFloat(valueString?.split('px')?.[0]) || 0;
};

const isMobile = () => {
  return navigator.userAgent.match(/(iPhone)|(iPod)|(android)|(webOS)/i);
};

const isIpadDevice = () => {
  return (
    navigator.userAgent.match(/(ipad)/i) ||
    (navigator?.platform === 'MacIntel' && navigator?.maxTouchPoints > 1)
  );
};

export const isIpad = Boolean(isIpadDevice());
export let isSmartPhone = Boolean(isMobile());

export const ObjectToArray = (object: any, type: any) => {
  let list: any[] = [];
  Object.entries(object).map(([key, myValue]) => {
    list.push({
      key: key,
      value: myValue,
      type
    });
  });

  list.sort((a, b) => {
    return parseInt(a.key.split('-')[0]) - parseInt(b.key.split('-')[0]);
  });

  return list;
};
export const getMatchStatus = (status: any, verified: any) => {
  if (status === 2 && !verified) {
    return '(Reviewed)';
  } else if (status === 2) {
    return '(Completed)';
  } else if (status === 3) {
    return '(Live)';
  } else if (status === 1) {
    return '(Scheduled)';
  } else {
    return '(Abandoned)';
  }
};
export const formatWinningsForLeaderboard = (
  winningsPerPosition: any,
  basePosition: any = 0,
  type: string = 'rupees'
) => {
  let lastPosition = basePosition + 1;
  const ranks: any = {};
  let formattedWinnings = Object.keys(winningsPerPosition)
    .sort((a: any, b: any) => b - a)
    .reduce((prev: any, cur) => {
      const start = lastPosition;
      const end = lastPosition + winningsPerPosition[cur];
      lastPosition = end;
      for (let i = start; i < end; i++) {
        ranks[i] = { value: Number(cur), type };
      }
      return ranks;
    }, {});

  return formattedWinnings;
};
export const roundTwoDecimalPlace = (amount: any) => {
  return Math.round((amount + Number.EPSILON) * 100) / 100;
};
export const random = (min: any, max: any) => Math.floor(Math.random() * (max - min)) + min;
export const sendMessageToIframe = (message: any) => {
  const iFameElem: any = document.getElementById('miniGameIframe');
  iFameElem?.contentWindow.postMessage(message, '*');
};
export const isEligibleWalletBalance = (balance: any, entryFee: any) => {
  return balance - entryFee >= 0;
};

export const redirectHyperLinks = (target: any) => {
  switch (target) {
    case 'instagram':
      window.location.href = 'https://instagram.com/igamioplay';
      break;
    case 'twitter':
      window.location.href = 'https://twitter.com/GamioTech';
      break;
    case 'igamio':
      window.location.href = 'https://www.gamiotech.com/';
      break;
    case 'youtube':
      window.location.href = 'https://youtube.com/@igamio3434';
      break;
    case 'facebook':
      window.location.href = 'https://www.facebook.com/igamioplay?mibextid=ZbWKwL';
      break;
    case 'linkedin':
      window.location.href = 'https://www.linkedin.com/company/gamiotech/';
      break;
    case 'aboutus':
      window.location.href = 'https://www.gamiotech.com/about-us/';
      break;
    case 'contactus':
      window.location.href = 'https://www.gamiotech.com/contact/';
      break;
    case 'careers':
      window.location.href = 'https://www.gamiotech.com/careers/';
      break;
    case 'pokerarticles':
      window.location.href = 'https://www.gamiotech.com/poker-articles/';
      break;
    case 'fantasyarticles':
      window.location.href = 'https://www.gamiotech.com/fantasy-articles/';
      break;
    case 'whitelabelpokersoftware':
      window.location.href = 'https://www.gamiotech.com/white-label-poker-software/';
      break;
    case 'fantasysportspublisherintegration':
      window.location.href = 'https://www.gamiotech.com/fantasy-sports-publisher-integration/';
      break;
    case 'gamionetwork':
      window.location.href = 'https://www.gamiotech.com/the-gamio-network/';
      break;
    case 'gamiodevelopment':
      window.location.href = 'https://www.gamiotech.com/game-development/';
      break;
    default:
      window.location.href = 'https://www.gamiotech.com/';
      break;
  }
};

export const randomUserName = () => {
  const userNameLists = [
    'Sanjay',
    'Akash',
    'Divya',
    'Soniya',
    'Arjun',
    'Deepak',
    'Rahul',
    'Kowshik',
    'Priya',
    'Shankar'
  ];
  const userNameProbability = random(0, userNameLists.length);
  return userNameLists[userNameProbability];
};
